export default "__VITE_ASSET__0W2eOPyd__"